import React from 'react';
import ReactDOM from 'react-dom';

import App, { BASENAME } from './components/app';

// This site used to be a HashRouter at the domain root, so old links look like
// nschneider.dev/#/projects. The edge redirects the path part to /about/ on
// the current domain, and
// browsers carry the fragment along, landing on /about/#/projects — which
// BrowserRouter ignores, silently showing the home page instead. Rewrite the
// fragment to the equivalent real path first so those links still work.
const legacyHash = window.location.hash;
if (legacyHash.startsWith('#/')) {
  window.history.replaceState(null, '', BASENAME + legacyHash.slice(1));
}

// this creates the store with the reducers, and does some other stuff to initialize devtools
// boilerplate to copy, don't have to know

// we now wrap App in a Provider
ReactDOM.render(
  <App />,
  document.getElementById('main'),
);
